import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import MediaWrapper from 'components/cards/shared/MediaWrapper'
import CollectionCard from 'components/cards/CollectionCard'

const Outer = styled.div`
  width: 100%;
  position: relative;
  border-radius: 6px;
`

type CollectionSlideProps = {
  item: {
    id: string
    name: string
    slug: string
    image?: Pick<GQL_Collection['image'], 'large' | 'medium'>
  }
}

const CollectionSlide = ({ item }: CollectionSlideProps) => {
  const { md: largerThanMd } = useMediaQueryContext()

  const { name, slug, image } = item

  const path = `/collections/${slug}`
  const target = largerThanMd ? '_blank' : undefined
  const rel = largerThanMd ? 'noopener noreferrer' : undefined

  return (
    <Outer>
      <a href={path} target={target} rel={rel}>
        <CollectionCard name={name} slug={slug} image={image} />
      </a>
    </Outer>
  )
}

export const PlaceholderCollectionSlide = () => {
  return (
    <Outer>
      <MediaWrapper portrait rounded />
    </Outer>
  )
}

export default CollectionSlide
